import { Environment } from 'ngx-paf-common';

export const pafEnvironment : Environment = {
  debug:  true,
  apiBaseUrl:  'https://api.paf.heiv.info/api/',
  portalType:  'INTRANET',
  oktaBaseUri:  'https://dev-53284405.okta.com/',
  production : false,
  authenticationType :  'azure',
  logo: 'LOGO_ALTRAD_ENDEL.png',
  logoUrl:  'https://www.altradendel.com/',
  logoNgStyle :  {'height':'55px','object-fit':'contains'}
};


export const  azureEnvironnent = {
  clientId:'75423db6-8e90-4846-a4e4-3338bfbfb991',
  authority: 'https://login.microsoftonline.com/02285139-4373-4712-8b87-391400e9fa31',
  apiBaseUrl :'https://api.paf.heiv.info/api/',
  protectedResourceScopes: ['api://280fd4ba-1391-4e57-8489-bb4fbe7f612e/access_as_user'],
  redirectUri: window.location.origin + '/' + window.location.pathname.split('/')[1] + '/login/callback',
  postLogoutRedirectUri: window.location.origin + '/' + window.location.pathname.split('/')[1] + '/loggedout',
}
